import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material/styles";

import Container from "../Container";

const Headline = ({
  pageTitle,
  title1,
  title2,
  title3,
  subtitle,
  children,
}) => {
  const theme = useTheme();

  return (
    <Box bgcolor={theme.palette.alternate.main}>
      <Container maxWidth={840}>
        <header>
          <Box mt={5} mb={8}>
            {pageTitle && (
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "medium",
                }}
                gutterBottom
                color={"textSecondary"}
                align={"center"}
              >
                {pageTitle}
              </Typography>
            )}
            <Typography
              component={"h1"}
              fontWeight={700}
              variant={"h3"}
              align={"center"}
            >
              {title1}{" "}
              <Typography
                color={"primary"}
                component={"span"}
                variant={"inherit"}
              >
                {title2}{" "}
              </Typography>
              {title3}
            </Typography>

            {subtitle && (
              <Box mt={3} mb={4}>
                <Typography
                  variant="h6"
                  component="h2"
                  align={"center"}
                  color={"textSecondary"}
                >
                  {subtitle}
                </Typography>
              </Box>
            )}
          </Box>
        </header>

        {children}
      </Container>
    </Box>
  );
};

export default Headline;
